if (!CSS.supports("grid-template-rows", "masonry")) {
    const grids = [...document.querySelectorAll(".social-teasers")].map(grid => ({
        element: grid,
        gap: parseFloat(getComputedStyle(grid).gridRowGap),
        items: [...grid.childNodes].filter(c => c.nodeType === 1),
        ncol: 0
    }));

    let timeout;

    const layout = (grid) => {
        /* get the post relayout number of columns */
        let ncol = getComputedStyle(grid.element).gridTemplateColumns.split(' ').length;

        /* update number of columns */
        grid.ncol = ncol;

        /* revert to initial positioning, no margin */
        grid.items.forEach(c => c.style.removeProperty('margin-top'));

        /* if we have more than one column */
        if (grid.ncol > 1) {
            const visibleItems = grid.items.filter(c => c.offsetParent !== null);
            visibleItems.slice(ncol).forEach((c, i) => {
                let prev_fin = visibleItems[i].getBoundingClientRect().bottom /* bottom edge of item above */,
                    curr_ini = c.getBoundingClientRect().top /* top edge of current item */;
                c.style.marginTop = `${prev_fin + grid.gap - curr_ini}px`
            });
        }
    }

    const resize = new ResizeObserver((entries) => {
        entries.forEach(entry => {
            layout(grids.filter(grid => grid.element === entry.target)[0]);
        })
    });

    const enter = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                layout(grids.filter(grid => grid.element === entry.target)[0]);
            }
        });
    });

    grids.forEach(grid => {
        enter.observe(grid.element);
        resize.observe(grid.element);

        if (grid.items.length > 12) {
            // Activate pagination
            grid.element.classList.add('paginated');
            grid.items.slice(0, 12).forEach(item => {
                item.classList.add('active');
            });

            // Create pagination
            const pagination = document.createElement('scale-pagination');
            pagination.setAttribute('page-size', 12);
            pagination.setAttribute('start-element', 0);
            pagination.setAttribute('total-elements', grid.items.length);
            pagination.addEventListener('scale-pagination', (event) => {
                const startIndex = event.detail.startElement;

                // Based on the start element of the event hide all other elements
                grid.items.forEach(item => {
                    item.classList.remove('active');
                });
                grid.items.slice(startIndex, startIndex + 12).forEach(item => {
                    item.classList.add('active');
                });

                // update layout of masonry
                layout(grid);

                grid.element.scrollIntoView();
            });
            grid.element.after(pagination);
        }
    })

    document.addEventListener('Neos.NodeCreated', (event) => {
        if (event.detail.node.get('nodeType') === 'App.Site:Content.SocialTeaser' && event.detail.element.childNodes.length === 0) {
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    });
}
